
const LayoutEvent = {};
export default LayoutEvent;

LayoutEvent.CHANGED = "LayoutEvent.CHANGED";
